import { Box, Flex, Text, Link, get, Image } from "theme-ui";
import { Instagram } from "react-feather";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import copy from "src/content/copy.json";
import { SOCIAL_NETWORKS } from "src/constants";
import { NavFooter } from "src/components/organisms/NavFooter/NavFooter";
import ios_icon from "src/assets/images/ios_icon.png";
import android_icon from "src/assets/images/android_icon.png";
import facebook_icon from "src/assets/images/facebook_icon.png";
import { STORES } from "src/constants";
import { extractBaseLang } from "src/utils";
import { RootState } from "src/redux/store";

export const Footer = () => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const currentLanguage = extractBaseLang(i18n.language);

  const {
    location: { country },
  } = useSelector((state: RootState) => state.visitor);

  const isDownloadVisible = currentLanguage === "es" || country === "AR";

  const socialJsx = [
    {
      img: <Instagram />,
      href: SOCIAL_NETWORKS.instagram,
      link: (
        <Text sx={{ verticalAlign: "super", pl: [4] }}>
          {copy["social_&_download_navigation"].instagram}
        </Text>
      ),
    },
    {
      img: <Image src={facebook_icon} width="22px" />,
      href: SOCIAL_NETWORKS.facebook,
      link: (
        <Text sx={{ verticalAlign: "super", pl: [4] }}>
          {copy["social_&_download_navigation"].facebook}
        </Text>
      ),
    },
  ];
  const downloadOption = [
    {
      img: <Image src={android_icon} width="22px" />,
      href: STORES.GOOGLE,
      link: (
        <Text sx={{ verticalAlign: "super", pl: [4] }}>
          {copy["social_&_download_navigation"].google}
        </Text>
      ),
    },
    {
      img: <Image src={ios_icon} width="22px" />,
      href: STORES.APPLE,
      link: (
        <Text sx={{ verticalAlign: "super", pl: [4] }}>
          {copy["social_&_download_navigation"].appStore}
        </Text>
      ),
    },
  ];
  return (
    <Box
      sx={{
        bg: "text",
        pt: [6],
        mt: [5],
      }}
    >
      <Box
        sx={{
          maxWidth: (theme) => get(theme, "breakpoints.2"),
          margin: "auto",
        }}
      >
        <Flex
          sx={{
            height: "auto",
            px: [4, 4, 7],
            flexDirection: ["column", "column", "row"],
          }}
        >
          <NavFooter onNavClick={navigate} />
          <Flex
            as="ul"
            sx={{
              listStyle: "none",
              p: 0,
              alignItems: "flex-start",
              gap: 1,
              flexDirection: "column",
              ml: [0, 0, "auto"],
              pr: isDownloadVisible ? 8 : 1,
              fontSize: [2, "15px"],
            }}
          >
            <Text
              sx={{
                color: "white",
                alignSelf: "baseline",
                fontWeight: "heading",
                pt: [6, 6, 0],
              }}
            >
              {t("social_&_download_navigation.follow")}
            </Text>

            {socialJsx.map((s, i) => {
              return (
                <Box key={i} as="li" sx={{ pt: [1, 1, 2] }}>
                  <Link
                    href={s.href}
                    target="_blank"
                    sx={{ color: "white", textDecoration: "none" }}
                  >
                    {s.img}
                    {s.link}
                  </Link>
                </Box>
              );
            })}
          </Flex>
          {isDownloadVisible && (
            <Flex
              as="ul"
              sx={{
                listStyle: "none",
                p: 0,
                alignItems: "flex-start",
                gap: 1,
                flexDirection: "column",
                fontSize: [2, "15px"],
              }}
            >
              <Text
                sx={{
                  color: "white",
                  alignSelf: "baseline",
                  fontWeight: "heading",
                  pt: [6, 6, 0],
                }}
              >
                {t("social_&_download_navigation.download")}
              </Text>
              {downloadOption.map((s, i) => {
                return (
                  <Box key={i} as="li" sx={{ pt: [1, 1, 2] }}>
                    <Link
                      href={s.href}
                      target="_blank"
                      sx={{ color: "white", textDecoration: "none" }}
                    >
                      {s.img}
                      {s.link}
                    </Link>
                  </Box>
                );
              })}
            </Flex>
          )}
        </Flex>
        <Box
          sx={{
            borderTop: "1px solid white",
            mt: [5, 5, "22px"],
            mx: [4, 4, 7],
            py: [2, 3, 3],
            textAlign: ["left", "left", "left"],
          }}
        >
          <Text sx={{ color: "white", fontSize: [1] }}>{copy.footer}</Text>
        </Box>
      </Box>
    </Box>
  );
};
